/** Sayfayı en üste kaydırır (rota değişimi / ilan detayı). */
export const scrollPageToTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};
